module.exports = "/* Work Offer Lookup CSS */\n"